'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoQrScanner = function IoQrScanner(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm7.3 9.7v5.3h-3.8v-5.3c0-2.6 2.2-4.7 4.8-4.7h5.2v3.8h-5.3c-0.6 0-1 0.3-1 0.9z m24-4.7c2.6 0 4.7 2.1 4.7 4.7v5.3h-3.7v-5.3c0-0.6-0.5-0.9-1.1-0.9h-5.2v-3.8h5.3z m1 25.2v-5.2h3.7v5.2c0 2.6-2.1 4.8-4.7 4.8h-5.3v-3.8h5.3c0.6 0 1-0.4 1-1z m-24.1 1h5.3v3.8h-5.2c-2.6 0-4.8-2.2-4.8-4.8v-5.2h3.8v5.2c0 0.6 0.3 1 0.9 1z' })
        )
    );
};

exports.default = IoQrScanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/qr-scanner.js
// module id = 2877
// module chunks = 168707334958949